<template>
  <div class="page">
    <custom-widget
      v-for="(item, index) in items"
      :key="'custom#' + index"
      :item="item"
    ></custom-widget>
  </div>
</template>

<script>
import { httpOpen } from "../../scripts/network";
import { savePageCache, getPageCache } from "../../scripts/page_cache";
// import { SHOW_NAV } from "../../store/mutation-types";
export default {
  name: "page",
  data() {
    return {
      info: null,
      items: []
    };
  },
  mounted() {
    window.scrollBy(0,0.1);
    this.getPageInfo(this.$route.params.id);
  },
  watch: {
    "info.title": function(value) {
      document.title = value || "品胜";
    },
    // "$route.params.id": function(value) {
    //   this.getPageInfo(value);
    // },
  },
  methods: {
    async sendVisitor(id) {
      let visitorCache = window.local.get("visitor");
      let date = new Date();
      let today =
        date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
      if (visitorCache && visitorCache.date === today) {
        let index = visitorCache.ids.findIndex(item => item === id);
        if (index != -1) {
          return;
        }
      } else {
        visitorCache = {
          date: today,
          ids: []
        };
      }
      visitorCache.ids.push(id);
      try {
        await httpOpen("/AssemblyPage/SetVisitorsVal", {
          type: "post",
          body: { PageId: id }
        });
        window.local.save("visitor", visitorCache);
      } catch (e) {
        console.error(e);
      }
    },
    async getPageInfo(id) {
      let ret;
      if (id) {
        ret = getPageCache(id);
        if (!ret) {
          ret = await httpOpen("/AssemblyPage/GetPage", {
            type: "post",
            body: { PageId: id }
          });
          savePageCache(id, ret);
        }
      } else {
        ret = getPageCache("home");
        if (!ret) {
          ret = await httpOpen("/AssemblyPage/GetMainPage", { type: "post" });
          savePageCache("home", ret);
        }
      }
      this.sendVisitor(ret.Data.PageBasicInfo.SysNo);
      this.info = this.infoMapper(ret.Data.PageBasicInfo);
      this.updateShare({
            title: this.info.title,
            desc: this.info.desc,
            image: this.info.icon,
            link: window.location.href
          });
      if (ret.Data.PageBasicExtension) {
        this.items = this.itemsMapper(ret.Data.PageBasicExtension.BasicExts);
      } else {
        this.items = null;
      }
    },

    infoMapper(info) {
      return {
        title: info.PageTitle,
        desc: info.PageProfiles,
        icon: info.PageIcon,
        showNav: info.IsNavigation
      };
    },
    itemsMapper(data) {
      return data
        .map(item => {
          switch (item.AssemTypeId) {
            case 1:
              return this.itemNavigatorMapper(item);
            case 2:
              return this.itemTopBackgroundMapper(item);
            case 4:
              return this.itemInterlayerMapper(item);
            case 3:
              return this.itemImageWidgetMapper(item);
          }
        })
        .filter(item => item);
    },
    itemNavigatorMapper(item) {
      return {
        type: item.AssemTypeId,
        data: {
          count: item.ButtonCount,
          showTitle: item.IsShowTitle === 1,
          textColor: item.TextColor || "#333333",
          items: item.ImageDetails.map(item => this.imageMapper(item))
        }
      };
    },
    itemTopBackgroundMapper(item) {
      return {
        type: item.AssemTypeId,
        data: {
          image: item.ImageDetails[0].ImageUrl
        }
      };
    },
    itemImageWidgetMapper(item) {
      return {
        type: item.AssemTypeId,
        data: {
          type: item.ImageType,
          shadow: item.IsShadow === 1,
          round: item.IsFillet === 1,
          items: item.ImageDetails.map(item => this.imageMapper(item))
        }
      };
    },
    itemInterlayerMapper(item) {
      return {
        type: item.AssemTypeId,
        data: {
          type: item.QuarantineType,
          showMore: item.IsShowMore === 1,
          url: item.LinkUrl,
          height: item.QuarantineHeight,
          start: item.StartTime && Date.parse(item.StartTime.replace(/-/g, '/').replace(/T/, ' ')).valueOf(),
          end: item.StartTime && Date.parse(item.EndTime.replace(/-/g, '/').replace(/T/, ' ')).valueOf(),
          image:
            item.ImageDetails &&
            item.ImageDetails.length > 0 &&
            item.ImageDetails[0].ImageUrl
        }
      };
    },
    imageMapper(data) {
      return {
        image: data.ImageUrl,
        title: data.ImageTitle,
        link: data.ImageLinkUrl
      };
    }
  }
};
</script>

<style scoped>

</style>
